import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PlayerPromoSendingModeEnum } from "@api-types/user/AccountActivationRequestDto";
import { ErrorMessage, RequiredMark } from "@components/inputs/shared";

export default function PartnerRegistrationPromotion() {
	const { t } = useTranslation("registration");

	return (
		<div className="form__group u-mar--top--sml">
			<div className="label u-type--base u-type--wgt--medium u-color--text--primary">
				{t("NEWSLETTER_LABEL")}
				<RequiredMark required />
			</div>
			<ErrorMessage name="playerPromoSendingMode" />

			<div className="form__field u-mar--bottom--3">
				<RadioInput
					id="newsletterCheckboxChecked"
					label="registration:NEWSLETTER_CHECKED"
					value={PlayerPromoSendingModeEnum.enabled}
				/>
			</div>

			<div className="form__field">
				<RadioInput
					id="newsletterCheckboxUnchecked"
					label="registration:NEWSLETTER_UNCHECKED"
					value={PlayerPromoSendingModeEnum.disabled}
				/>
			</div>
		</div>
	);
}

function RadioInput(props: {
	id: string;
	label: string;
	value: PlayerPromoSendingModeEnum;
}) {
	const { id, label, value } = props;

	const { t } = useTranslation();
	const { register } = useFormContext();

	const field = register("playerPromoSendingMode", {
		required: {
			value: true,
			message: "COMMON.REQUIRED_FIELD",
		},
	});

	return (
		<div className="input--radio input--radio--sml">
			<input
				id={id}
				className="input--radio__box input--radio--sml__box"
				type="radio"
				value={value}
				{...field}
			/>
			<label
				htmlFor={id}
				className="input--radio__label input--radio--sml__label"
			>
				{t(label)}
			</label>
		</div>
	);
}
